export function isMissingAccountError(error: string): boolean {
  return error.includes('MissingRoomexUserAccount');
}

export function isPendingInvitationError(error: string): boolean {
  return error.includes('PendingRoomexUserInvitation');
}
